import React from "react"

const NetworkInvitationsContext = React.createContext({})

const { Provider, Consumer } = NetworkInvitationsContext

export { Provider, Consumer, NetworkInvitationsContext }
